import React from 'react';
import { Typography, Link, Alert } from '@one-thd/sui-atomic-components';
import { Controller } from 'react-hook-form';
import { FooterButtons } from '../footer-buttons';
import { ManageUsersTable } from '../../../manage-user-roles/user-roles-table';
import { useManageUserForm } from '../../../../hooks/use-manage-user-form';
export var UserTypeSection = function (_a) {
    var isActive = _a.isActive, isCompleted = _a.isCompleted, shouldDisableEditing = _a.shouldDisableEditing, continueHandler = _a.continueHandler, editHandler = _a.editHandler, cancelHandler = _a.cancelHandler;
    var _b = useManageUserForm(), formMethods = _b.formMethods, handleUserTypeChange = _b.handleUserTypeChange;
    var control = formMethods.control, watch = formMethods.watch, trigger = formMethods.trigger;
    var selectedRole = watch('role');
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-8 sui-mb-4" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                React.createElement(Typography, { variant: "h5", color: isActive || isCompleted ? 'primary' : 'inactive' }, "User Type"),
                isCompleted && (React.createElement(Link, { "data-testid": "user-type-edit-btn", component: "button", className: shouldDisableEditing
                        ? 'sui-text-inactive sui-pointer-events-none sui-opacity-60 sui-text-base'
                        : 'sui-text-base sui-font-regular sui-text-primary sui-underline', onClick: shouldDisableEditing ? undefined : editHandler, "aria-disabled": shouldDisableEditing }, "Edit"))),
            !isActive && selectedRole && React.createElement(Typography, null, selectedRole),
            isActive && (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(Typography, null, "Select the type of account this user will have."),
                React.createElement("div", { className: "sui-w-[370px] sm:sui-w-[561px]" },
                    React.createElement(Controller, { name: "role", control: control, render: function (_a) {
                            var _b;
                            var field = _a.field, errors = _a.formState.errors;
                            var value = field.value, onChange = field.onChange;
                            var onChangeWrapper = function (role) {
                                handleUserTypeChange(role);
                                onChange(role);
                            };
                            return (React.createElement(React.Fragment, null,
                                React.createElement(ManageUsersTable, { role: value, onClick: onChangeWrapper }),
                                !selectedRole && errors.role && (React.createElement("div", { className: "sui-mt-4" },
                                    React.createElement(Alert, { status: "error" }, (_b = errors.role) === null || _b === void 0 ? void 0 : _b.message)))));
                        } })),
                React.createElement("div", { className: "sui-mb-4" },
                    React.createElement(FooterButtons, { continueText: "Continue", continueHandler: function () {
                            trigger(['role']).then(function (passed) {
                                if (passed) {
                                    continueHandler();
                                }
                            });
                        }, cancelHandler: cancelHandler })))))));
};
